import React, { useState } from "react";
import DashTable from "./DashTable";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../../Component/DigitalMarketing/SearchBox";
import Pagination from "../../../../Component/DigitalMarketing/Pagination";


const PrescribedTests = () => {
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState(1);

  // const onChangeSearch = (event: any) => {
  //   setSearchValue(event.target.value);
  // };

  return (
    <div>
      <Row>
        <Col md={5}>
          <SearchBox value={searchValue} />
        </Col>
      </Row>

      <div className="row mt-4">
        <div className="col-12">
          <DashTable searchValue={searchValue} />
        </div>
        <Pagination setPagination={setPagination} pagination={pagination} />
      </div>
    </div>
  );
};

export default PrescribedTests;
